<template> <!-- OK -->
  <div class="cadastro-form">
    <h2>Cadastro de Usuários</h2>
    <form @submit.prevent="registerUser">
      <div class="form-row">
        <div class="form-group full-width">
          <label for="fullName">Nome Completo:</label>
          <input type="text" id="fullName" v-model="fullName" required/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label for="username">Nome de Usuário:</label>
          <input type="text" id="username" v-model="username" required/>
        </div>
        <div class="form-group">
          <label for="phone">Telefone:</label>
          <input type="tel" id="phone" v-model="phone" required/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label for="password">Senha:</label>
          <input type="password" id="password" v-model="password" required/>
        </div>
        <div class="form-group">
          <label for="confirmPassword">Confirmar Senha:</label>
          <input type="password" id="confirmPassword" v-model="confirmPassword" required/>
        </div>
      </div>
      <p v-if="!carregandoUsuarios">
        Usuários cadastrados: {{ quantidadeUsuarios }} / {{ limiteUsuarios }}
      </p>
      <p v-if="!podeCadastrar" style="color: red;">
        Limite de usuários atingido para este plano.
      </p>
      <button type="submit" :disabled="!podeCadastrar">
        Cadastrar
      </button>
    </form>
    <div class="back-button">
      <button @click="goBack">Voltar para Administração</button>

    </div>
  </div>
</template>

<script>

import userService from "@/services/userService";

export default {
  name: 'Register',
  data() {
    return {
      fullName: '',
      username: '',
      phone: '',
      password: '',
      confirmPassword: '',

      quantidadeUsuarios: 0,
      limiteUsuarios: 51 - 1, // ESSE -1 é pq sou cadastrado como usuário
      carregandoUsuarios: false
    };
  },
  computed: {
    podeCadastrar(){
      return this.quantidadeUsuarios < this.limiteUsuarios;
    },
  },
  async mounted() {
    await this.carregarQuantidadeUsuarios();
  },
  methods: {
    async carregarQuantidadeUsuarios() {
      try{
        this.carregandoUsuarios = true;

        const response = await userService.getAllUsers();
        this.quantidadeUsuarios = response.data.length - 1;
      } catch (error) {
        console.error('Erro ao carregar qtde de usuários', error);
        alert('Erro ao carregar qtde de usuários');
      } finally {
        this.carregandoUsuarios = false;
      }
    },
    async registerUser() {
      if (!this.podeCadastrar){
        alert("Limite de usuários atingido para este plano.");
        return;
      }

      if (this.password !== this.confirmPassword) {
        alert("As senhas não coincidem!");
        return;
      }

      try {
        const response = await userService.registerUser({
          fullName: this.fullName,
          username: this.username,
          phone: this.phone,
          password: this.password
        })

        console.log("Resposta do servidor:", response);

        alert(response.data.message);

        this.fullName = '';
        this.username = '';
        this.phone = '';
        this.password = '';
        this.confirmPassword = '';

        await this.carregarQuantidadeUsuarios();

      } catch (error) {
        console.error('Erro ao registrar usuário:', error);
        if (error.response && error.response.data) {
          alert(error.response.data.message);
        } else {
          alert('Erro ao conectar ao servidor. Por favor, tente novamente.');
        }
      }
    },
    goBack() {
      this.$router.push('/admin');
    },
  }
};
</script>

<style scoped>
.cadastro-form {
  width: 70%;
  padding: 2rem;
  background-color: #FFF;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.cadastro-form h2 {
  text-align: center;
  margin-bottom: 1.5rem;
}

.form-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.form-group {
  width: 48%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #CCC;
  border-radius: 4px;
}

.form-group.full-width {
  width: 100%;
}

button {
  width: 100%;
  padding: 0.75rem;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;
}

button:hover {
  background-color: #0056B3;
}


@media (max-width: 425px) {
  .cadastro-form {
    width: 100%;
    padding: 1rem;
  }

  .form-row {
    flex-direction: column;
  }

  .form-group {
    width: 100%;
    margin-bottom: 1rem;
  }

  .cadastro-form h2 {
    font-size: 1.5rem;
  }

  .form-group input {
    padding: 0.75rem;
  }

  button {
    font-size: 1rem;
  }
}

@media (max-width: 769px) {
  .cadastro-form {
    width: 70%;
    padding: 2rem;
  }

  .cadastro-form h2 {
    font-size: 2rem;
  }

  .form-group input {
    padding: 0.5rem;
  }

  button {
    font-size: 1rem;
  }

}
</style>
